export type EdgeApiResponse<TResult = any> = {
    err?: number
    errmsg?: string
    id: string
    method: string
    responseVer: number
    result: TResult | null
}

export const fetchStatusResolver = (response: Response) => {
    if (response.status === 200) {
        return response
    } else {
        throw new Error(`${response.status}: ${response.statusText}`)
    }
}

/** The result of an edge response, or its error as a thrown Error */
export const handleEdgeError = <T>(
    res: EdgeApiResponse<T>,
    context: string,
): NonNullable<T> => {
    if (res.err || !res.result) {
        throw new Error(`[${context}] ${res.errmsg || 'Unknown error'}`)
    }
    return res.result as NonNullable<T>
}
